var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"calc(100% - 200px)","margin":"auto"}},[(_vm.$route.path === '/recruits/story')?_c('StoryList',{attrs:{"PCTRLLOG":_vm.CTRLLOG}}):_vm._e(),_vm._v(" "),(_vm.$route.path.indexOf('recruits/storyedit') >= 0)?_c('StoryEdit'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-642ce088","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RecruitStory.vue
// module id = null
// module chunks = 